import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth';
import { api } from '@/utils/api';
export interface Resource<T> { data: T | null; loading: boolean; error: string | null; reload: () => void }
export function useProfileResource<T>(path: string, parse: (body: any) => T): Resource<T> {
  const { user } = useAuthStore();
  const identity = `${user?.tenantId}:${user?.id}:${user?.role?.name}:${path}`;
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState<{ identity: string; data: T | null; error: string | null; loading: boolean }>({ identity, data: null, error: null, loading: true });
  useEffect(() => {
    let current = true;
    setState({ identity, data: null, error: null, loading: true });
    Promise.resolve().then(() => api.get(path)).then(response => {
      if (response.data?.success === false) throw new Error('Request failed');
      const data = parse(response.data);
      if (current) setState({ identity, data, error: null, loading: false });
    }).catch(() => { if (current) setState({ identity, data: null, error: 'Could not load this section.', loading: false }); });
    return () => { current = false; };
  }, [identity, revision, path, parse]);
  return { ...(state.identity === identity ? state : { data: null, error: null, loading: true }), reload: () => setRevision(n => n + 1) };
}
export function arrayData<T>(body: any): T[] {
  if (!Array.isArray(body?.data)) throw new Error('Invalid list response');
  return body.data;
}
